/**
 * Класс валидации поля с именем.
 */
export class ValidateNameInput {
    constructor(el) {
        this.el = el;
        this.bindEventlisteners();
    }

    /**
     * Запрет ввода чисел в поле имени.
     *
     * @returns {void}
     */
    preventEnteringNumbersInFieldName() {
        this.el.value = this.el.value.replace(/[+$№^*)@:,.'`";_=<>%#~&!\\(?{}[\]/|\d]/g, "");
    }

    /**
     * Прослушивание событий.
     *
     * @returns {void}
     */
    bindEventlisteners() {
        this.el.addEventListener("input", () => {
            this.preventEnteringNumbersInFieldName();
        });

        this.el.addEventListener("paste", () => {
            this.preventEnteringNumbersInFieldName();
        });
    }
}

document.querySelectorAll(".js-name-input").forEach((elem) => new ValidateNameInput(elem));